import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-migration-notice-modal',
    standalone: true,
    imports: [CommonModule, NzButtonModule, NzModalModule],
    templateUrl: './migration-notice-modal.component.html',
    styleUrl: './migration-notice-modal.component.scss'
})
export class MigrationNoticeModalComponent {
    @Input() visible = false;

    @Output() acknowledge = new EventEmitter<void>();

    onAcknowledge(): void {
        this.acknowledge.emit();
    }
}
